import React = require("react");
import { getSurveyStatus, Segmentation, Survey, LanguageCode, SurveySegmentation } from '../../../amorg-common';
import { Button } from "../../../designSystem/button/Button";
import { FlexItem, Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Pill } from "../../../designSystem/pill/Pill";
import { updateSurveySegmentation } from "../../../api/surveyClientApi";
import { Card } from "../../../designSystem/Card";
import { Label } from "../../../designSystem/Label";

type SegmentationListProps = {
    survey: Survey,
    selectedLanguage:LanguageCode,
    onSelectForEdit: (segmentationIndex: number) => void,
    onSurveyUpdated: () => void,
}
export function SegmentationList(props: SegmentationListProps): JSX.Element {
    const disableEdit = !getSurveyStatus(props.survey).canEdit;

    function getSelectedSegmentation(seg:SurveySegmentation):Segmentation
    {
        if(props.selectedLanguage===props.survey.languageCode)
            return {name:seg.name, values:seg.values};
        
        const trans = seg.translations.find(t => t.languageCode===props.selectedLanguage);
        if(!trans) throw new Error('Missing translation');
        return { name:trans.name, values:trans.values };
    }


    async function handleMoveSegment(move: 'up' | 'down', segIndex) {

        if (move === 'up') {
            if (segIndex > 0) {
                await updateSurveySegmentation(props.survey.id, segIndex, segIndex-1, props.survey.segmentations[segIndex]);
                props.onSurveyUpdated();
            }
        }
        if (move === 'down') {
            if (segIndex < props.survey.segmentations.length - 1) {
                await updateSurveySegmentation(props.survey.id, segIndex, segIndex+1, props.survey.segmentations[segIndex]);
                props.onSurveyUpdated();
            }
        }
    }

    return (
        <Card variant="outlined">
            <Flex flexDirection="column" gap={16}>
            {props.survey.segmentations.map((c, i) => {

                const seg = getSelectedSegmentation(c);
                
                return (
                    <div key={seg.name}>
                        <Flex flexDirection="column" gap={4}>
                            <Flex>
                                <FlexItem flexGrow="1">
                                    <Label>{seg.name}</Label>
                                    
                                    {!disableEdit &&
                                        <Button variant="text" icon="interface_actions_edit" onClick={() => !disableEdit && props.onSelectForEdit(i)} />
                                    }
                                </FlexItem>
                                {!disableEdit &&
                                    <FlexItem>
                                        <Button variant="text" icon="arrows_arrow_arrowDown" onClick={() => handleMoveSegment('down', i)} />
                                        <Button variant="text" icon="arrows_arrow_arrowUp" onClick={() => handleMoveSegment('up', i)} />
                                    </FlexItem>
                                }
                            </Flex>

                            <Flex flexDirection="row" gap={8} flexWrap="wrap" style={{flexShrink:'0'}}>
                                {seg.values.map((value) =>
                                    <Pill key={value} identifier={value}>{value}</Pill>
                                )}
                            </Flex>
                        </Flex>        
                    </div>
                );
            })}
            
            {props.survey.segmentations.length === 0 &&
                <p>
                    Der er ikke oprettet nogen segmenteringer. Med segmenteringer kan du inddele respondenter efter arbejdssted, afdeling, aldersgruppe mm.
                </p>
            }
            </Flex>
        </Card>
        
    );
}